import { Link } from "react-router-dom";
import { ShieldX } from "lucide-react";
import CuoButton from "@/app/admin/_common/CuoButton";

export default function NoAccessPage() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
      <ShieldX className="size-8 text-muted-foreground" />
      <h1 className="text-lg font-semibold">You do not have access to this page</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        Ask an admin to grant your account the right role if you think this is a
        mistake.
      </p>
      <CuoButton asChild variant="outline">
        <Link to="/admin/home">Back to home</Link>
      </CuoButton>
    </div>
  );
}
